import mapFunction from './mapResources';

export default mapFunction('stores', {
    isFetching: false,
    items: [] 
});